// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Row, Col, Checkbox } from "@components";
import type {
  Alert,
  AlertServiceLength,
  AlertServiceLengthPeriodType,
} from "@modules/service/reducer/alerts/types";
import { AlertServiceLengthPeriodTypeEnum } from "@modules/service/reducer/alerts/constants";

type Props = $Exact<{
  data: Alert,
  ...PropsFromLocalize,
}>;

export class AlertServiceLengthView extends React.Component<Props> {
  get data(): ?AlertServiceLength {
    return this.props.data ? this.props.data.serviceLength : null;
  }

  get isEnabled(): boolean {
    return !!this.data;
  }

  getLocalizedPeriodType = (
    periodType: AlertServiceLengthPeriodType = AlertServiceLengthPeriodTypeEnum.DAY,
  ): string => {
    switch (periodType) {
      case "M":
        return this.props.t("MONTHS");
      case "W":
        return this.props.t("WEEKS");
      case "D":
      default:
        return this.props.t("DAYS");
    }
  };

  get label(): React$Node {
    if (!this.isEnabled) {
      return (
        <div className="d-flex">
          <span>{this.props.t("ALERT_DETAILS_SERVICE_LENGTH_RESTRICT_LESS_THAN")}</span>
          <span className="text-grey font-weight-bold pl-3">
            {this.props.t("ALERT_DETAILS_SERVICE_LENGTH_UNRESTRICTED")}
          </span>
        </div>
      );
    }

    return (
      <div className="d-flex">
        <span>
          {(this.data || {}).moreOrLessThan === "MORE_THAN"
            ? this.props.t("ALERT_DETAILS_SERVICE_LENGTH_RESTRICT_MORE_THAN")
            : this.props.t("ALERT_DETAILS_SERVICE_LENGTH_RESTRICT_LESS_THAN")}
        </span>
        <span className="text-black font-weight-bold pl-3">
          {(this.data || {}).duration || ""}
          {this.getLocalizedPeriodType((this.data || {}).periodType)}
        </span>
      </div>
    );
  }

  render() {
    return (
      <Row className="d-flex justify-content-center mb-5">
        <Col sm={12}>
          <Checkbox id="service-length" label={this.label} checked={this.isEnabled} disabled />
        </Col>
      </Row>
    );
  }
}

export default localize()(AlertServiceLengthView);
